import { createSelector } from '@reduxjs/toolkit';
import { selectAppServiceState } from '@vlabs/shared/selectors/appSelectors';
import { selectListsState } from '@vlabs/shared/selectors/listSelectors';

import { selectHandlersState } from '@vlabs/pages/handlers/selectors';

export const selectEvents = (state) => state.events;
export const selectEventsFilters = (state) => state.events.filters;
export const selectFilterCounts = (state) => state.events.filterCounts;
export const selectIsTopMatchHiding = (state) => state.events.isTopMatchHiding;

export const selectEventsState = createSelector(
  (state) => selectAppServiceState(state, 'lunaPlatform'),
  selectHandlersState,
  selectListsState,
  (...args) => {
    if (args.every((i) => i === 'loaded')) {
      return 'loaded';
    }
    return 'failed';
  },
);
